import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api/api.service';
import { Subject } from 'rxjs';

export interface CoreSearchFileFilters {
  isActive: boolean;
  fileNo: boolean;
  name: boolean;
  tckn: boolean;
  phone: boolean;
}

export interface CoreSearchFilters {
  limit: number,

  case: {
    isActive: boolean,
    name: boolean,
    caseNo: boolean,
    emergencyNo: boolean,
    labmedNo: boolean,
    insuranceNo: boolean,
    paymentNo: boolean
  },
  appointment: {
    isActive: boolean,
    name: boolean,
    caseNo: boolean,
    emergencyNo: boolean,
    labmedNo: boolean,
    insuranceNo: boolean,
  },
  organization: {
    isActive: boolean,
    name: boolean,
    orgNo: boolean
  },
  patientFiles: CoreSearchFileFilters;
  //  Tıbbı Danışmanlık Eklenmedi
  /*
  patient: {
    isActive: boolean,
    tckn: boolean,
    name: boolean,
    phone: boolean,
    mail: boolean
  },
  institution: {
    isActive: boolean,
    title: boolean,
    plate: boolean,
    phone: boolean,
  }
  */
}

export interface CoreSearchSettings { 
  openInNewPage: boolean,
  hideBackground: boolean,
  openFavorites: boolean,

  filters: CoreSearchFilters

}

export interface CoreSearchData {

  id: number,
  type: 'case' | 'appointment' | 'organization' | 'patientFiles',

  //  organization
  name?: string,
  date?: Date,
  no?: number,

  //  appointment && case
  caseType?: string,
  recordType?: string,
  patientFullName?: string,
  protocolNo?: string,
  labmedNo?: string,
  provisionNo?: string,
  caseInformationId?: number,
  patientId?: number,
  paymentId?: number,
  phones?: string[],
  idNumber?: string,
  
  fileNo?: string | number,

}

export interface CoreSearchResult {
  cases: CoreSearchData[],
  appointments: CoreSearchData[],
  organizations: CoreSearchData[],
  patientFiles: CoreSearchData[] 
}

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  private readonly searchTriggerSource = new Subject<void>();
  searchTrigger$ = this.searchTriggerSource.asObservable();

  constructor(private readonly service: ApiService) {}

  search(text: string, filters: CoreSearchFilters) {
    return this.service.post<CoreSearchResult>(`search`, {...filters, text});
  }

  loadSettingsFromStorage(): CoreSearchSettings {
    const storage = localStorage.getItem('search_settings');
    const defaults = this.getDefaulthSettings();

    if (!storage) {
      localStorage.setItem('search_settings', JSON.stringify(defaults));
      return defaults;
    }

    const parsed = JSON.parse(storage) as Partial<CoreSearchSettings>;

    const settings: CoreSearchSettings = {
      ...defaults,
      ...parsed,
      filters: {
        ...defaults.filters,
        ...(parsed.filters ?? {}),
        case: {
          ...defaults.filters.case,
          ...(parsed.filters?.case ?? {}),
        },
        appointment: {
          ...defaults.filters.appointment,
          ...(parsed.filters?.appointment ?? {}),
        },
        organization: {
          ...defaults.filters.organization,
          ...(parsed.filters?.organization ?? {}),
        },
        patientFiles: {
          ...defaults.filters.patientFiles,
          ...(parsed.filters as { patientFiles?: typeof defaults.filters.patientFiles })
            ?.patientFiles,
        },
      },
    };

    localStorage.setItem('search_settings', JSON.stringify(settings));
    return settings;
  }

  getDefaulthSettings(): CoreSearchSettings {
    return {
      openInNewPage: true,
      hideBackground: false,
      openFavorites: true,

      filters: {
        limit: 10,
        case: {
          isActive: true,
          caseNo: true,
          name: true,
          emergencyNo: false,
          labmedNo: false,
          insuranceNo: false,
          paymentNo: false
        },
        appointment: {
          isActive: true,
          caseNo: true,
          name: true,
          emergencyNo: false,
          labmedNo: false,
          insuranceNo: false
        },
        organization: {
          isActive: true,
          name: true,
          orgNo: true
        },
        patientFiles: {
          isActive: true,
          fileNo: true,
          name: true,
          tckn: true,
          phone: true,
        }
        /*
        patient: {
          isActive: true,
          name: true,
          mail: true,
          phone: true,
          tckn: true
        },
        institution: {
          isActive: true,
          phone: true,
          title: true,
          plate: true
        }
        */
      }
    
  }
  }

  triggerSearch() {
    this.searchTriggerSource.next();
  }

}
